import { render, staticRenderFns } from "./ProjectInfoCom.vue?vue&type=template&id=19587964&"
import script from "./ProjectInfoCom.vue?vue&type=script&lang=ts&"
export * from "./ProjectInfoCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports